import BaseComponent from '../abstracts/BaseComponent';
import { DataLayerUtils } from '../utilities/DataLayer';
import { get } from '../libs/Axios';

export default class ColorSelectionComponent extends BaseComponent {
  get Messages() {
    return {
      // [this.CUSTOM_MESSAGES.SELECT_SIZE_EVENTS.selected]: this.changeUrl
    };
  }

  constructor(element) {
    super(element);
    this.handleClick();
  }

  getUrlQuery(url) {
    const [baseLink, query] = url.split('?');

    return {
      baseLink,
      query
    };
  }

  handleClick() {
    this.$on('click.colors', async (e) => {
      e.preventDefault();
      const swatchEndpoint = e.target.getAttribute('data-swatch-endpoint');
      const variationAttribute = e.target.dataset.swatchColor;

      if (swatchEndpoint) {
        const { data } = await get(swatchEndpoint);
        const { product } = data;
        window.location.assign(this.getUrl(`${product.id}.html`));
      } else {
        DataLayerUtils.push({
          gaHitType: 'event',
          event: 'pdp_interactions',
          eventCategory: 'pdp',
          eventAction: 'select_variant',
          eventLabel: (variationAttribute || null)
        });

        window.location.assign(e.target.getAttribute('href'));
      }
    }, this.$el, 'a');
  }

  // async changeUrl({ product }) {
  //   const links = this.$el.querySelectorAll('a');
  //   const { variationAttributes } = product;
  //   const [colors] = variationAttributes.filter(attr => attr.swatchable).map(({ values }) => values).map(url => url);

  //   links.forEach((link) => {
  //     const { swatchId } = link.dataset;
  //     const { url } = colors.find(({ id }) => id === swatchId);
  //     link.setAttribute('data-swatch-endpoint', url);
  //   });
  // }

  getUrl(productId) {
    const pageUrl = window.location.pathname;
    return pageUrl.replace(/\/[^/]*$/, `/${productId}`);
  }
}
